import script from "./ExploreTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExploreTab.vue?vue&type=script&setup=true&lang=ts"

import "./ExploreTab.vue?vue&type=style&index=0&id=889f614a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-889f614a"]])

export default __exports__